import { Anchor, Icon, Tooltip } from 'components/atoms';
import React from 'react';
import { useTranslation } from 'utils/hooks';

import css from './Scheinunternehmen.module.scss';

interface ScheinunternehmenProps
{
  status: string;
}

const Scheinunternehmen: React.FC<ScheinunternehmenProps> = (props) =>
{
  const { status } = props;
  const { t } = useTranslation('profiles');

  return (
    <div className={css.container}>
      <span className={css.scheinunternehmen}>
        {t('profiles:unternehmen.status.scheinunternehmen')}
      </span>
      <span>({status})</span>
      <Tooltip
      side="bottom"
      align='center'
      content={
        <div className={css.tooltip}>
          {t('profiles:unternehmen.status.scheinunternehmenTooltip')}
        </div>
      } >
        <span>
          <Anchor href='https://service.bmf.gv.at/service/allg/lsu/' rel="noreferrer" target='_blank'>
            <Icon name="info" />
          </Anchor>
        </span>
      </Tooltip>

    </div>
  );
};

export default Scheinunternehmen;
